/* eslint-disable no-restricted-imports */
import type { BeforeRequestHook } from 'ky';

import { useLocaleStore } from '~/store/locale.store';

/**
 * Ky beforeRequest hook — injects Accept-Language header from locale store.
 * Uses `.getState()` (static) — never the React hook.
 */
export const localeInterceptor: BeforeRequestHook = (request) => {
  const locale = useLocaleStore.getState().activeLocale;
  request.headers.set('Accept-Language', locale);
};
